import { Component, inject, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { AmlWalletData, Rental, RentalDto, ReportEntity, WalletWithRentalDto } from '../../../../../api/api.model';
import { ApiService } from '../../../../../api/api.service';
import { AuthService } from '../../../../services/auth.service';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { DatePipe, LowerCasePipe, NgClass, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CropWithDotsCenterPipe } from '../../../../pipes/crop-with-dots-center.pipe';
import { ReportExposuresComponent } from '../../../report-partial/report-exposures/report-exposures.component';
import {
  ReportIdentificationComponent
} from '../../../report-partial/report-identification/report-identification.component';
import { ReportTriggersComponent } from '../../../report-partial/report-triggers/report-triggers.component';
import { ConvertNetworkToTokenPipe } from '../../../../pipes/convert-netwrok-to-token.pipe';

@Component({
  selector: 'app-aml-wallet-report',
  imports: [
    MatTableModule,
    MatExpansionModule,
    NgClass,
    DatePipe,
    TranslateModule,
    MatIconModule,
    CropWithDotsCenterPipe,
    NgOptimizedImage,
    CdkAccordionModule,
    MatTooltipModule,
    MatButtonModule,
    ReportIdentificationComponent,
    ReportExposuresComponent,
    ReportTriggersComponent,
    MatTabsModule,
    NgTemplateOutlet,
    ConvertNetworkToTokenPipe,
    LowerCasePipe
  ],
  templateUrl: './aml-wallet-report.component.html',
  styleUrl: './aml-wallet-report.component.scss',
  host: {
    class: 'p-4 flex flex-col',
  }
})
export class AmlWalletReportComponent {
  public readonly report: InputSignal<ReportEntity<AmlWalletData>> = input.required();
  public readonly startTrialSuccess: WritableSignal<boolean> = signal(false);
  public readonly walletRental: WritableSignal<Rental | RentalDto | null> = signal(null);
  public readonly disableButton: WritableSignal<boolean> = signal(false);
  public readonly scrolledDown: WritableSignal<boolean> = signal(false);
  public readonly authService: AuthService = inject(AuthService);

  private readonly _apiService: ApiService = inject(ApiService);

  private readonly translateService: TranslateService = inject(TranslateService);
  currentLang = this.translateService.currentLang;

  ngOnInit() {
    console.log(this.report());
    this.getRentalWallet();
  }

  onScroll = () => {
    if (window.scrollY > 300) {
      this.scrolledDown.set(true);
    } else {
      this.scrolledDown.set(false);
    }
  }

  private getRentalWallet(): void {
    this._apiService.getSubscribedWallets().pipe(take(1)).subscribe({
      next: (wallets: WalletWithRentalDto[]) => {
        if (wallets && wallets.length > 0) {
          const wallet = wallets.find((item: WalletWithRentalDto) => item.wallet.address === this.report().address);
          if (wallet) {
            this._apiService.getRentalWallet(wallet.wallet.uuid).pipe(take(1)).subscribe({
              next: (value: Rental[]) => {
                if (value && value.length > 0) {
                  this.walletRental.set(value[0]);
                } else {
                  this.walletRental.set(wallet.latestExpired);
                }
              }
            });
          }
        }
      }
    });
  }
}
